import { skillsBlacklist } from "@aglocal/types";
import normalizeSkill from "./normalizeSkill";
const EXCLUDED_SKILLS = new Set(skillsBlacklist.map(normalizeSkill));
export function isExcludedSkill(skill) {
    return EXCLUDED_SKILLS.has(normalizeSkill(skill));
}
export default function filterSkills(skills) {
    return skills.filter((skill) => !isExcludedSkill(skill));
}
